function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Menu, Button, Drawer, Avatar, Image, Space, Input, Layout, Modal } from "antd";
import { Container, Row, Col } from "react-bootstrap";
import { DownOutlined } from '@ant-design/icons';
import Common from "../components/includes/Common";
import AccountNav from "../components/AccountNav";
import { Link, Outlet, useNavigate, useParams } from "react-router-dom";
import UserConnectDrawer from "../components/UserConnectDrawer";
import NewEventBox from "../components/NewEventBox";
import { HouseFill, MegaphoneFill, DoorOpenFill, AwardFill, Grid3x3GapFill, Facebook, CalendarEventFill, GeoAltFill, PlayCircleFill, Twitter } from 'react-bootstrap-icons';
import BookTicket from "../components/forms/BookTicket";
import EventDetails from "../components/EventDetails";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Search = Input.Search;
var Header = Layout.Header,
  Content = Layout.Content,
  Footer = Layout.Footer,
  Sider = Layout.Sider;
var Home = function Home(_ref) {
  var _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? 'home' : _ref$selected;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    drawerVisible = _useState2[0],
    setDrawerVisible = _useState2[1];
  var showDrawer = function showDrawer() {
    setDrawerVisible(true);
  };
  var onDrawerClose = function onDrawerClose() {
    setDrawerVisible(false);
  };
  var _useState3 = useState(Common.currentUser != null),
    _useState4 = _slicedToArray(_useState3, 2),
    userIsConnected = _useState4[0],
    setUserIsConnected = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    connectDrawerVisible = _useState6[0],
    setConnectDrawerVisible = _useState6[1];
  var showConnectDrawer = function showConnectDrawer() {
    setConnectDrawerVisible(true);
  };
  var onConnectDrawerClose = function onConnectDrawerClose() {
    setConnectDrawerVisible(false);
    hideDrawer();
  };
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isEventBoxVisible = _useState8[0],
    setIsEventBoxVisible = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isTicketBookVisible = _useState10[0],
    setIsTicketBookVisible = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    selectedEvent = _useState12[0],
    setSelectedEvent = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    showEventDetails = _useState14[0],
    setShowEventDetails = _useState14[1];
  var navigate = useNavigate();
  var _useState15 = useState(selected),
    _useState16 = _slicedToArray(_useState15, 2),
    current = _useState16[0],
    setCurrent = _useState16[1];
  var handleClick = function handleClick(e) {
    setCurrent(e.key);
  };
  var user = Common.currentUser;
  var menuItems = [{
    label: /*#__PURE__*/_jsx("a", {
      className: "navbar-brand",
      href: "#",
      children: /*#__PURE__*/_jsx("div", {
        className: "nav-logo",
        children: /*#__PURE__*/_jsx("img", {
          src: "drawables/nl1_rm.png",
          style: {
            width: '100%',
            marginTop: '0px'
          }
        })
      })
    }),
    key: 'logo'
  }, {
    label: /*#__PURE__*/_jsx("span", {
      children: "Accueil"
    }),
    key: 'home',
    icon: /*#__PURE__*/_jsx(HouseFill, {})
  }, {
    label: /*#__PURE__*/_jsx("span", {
      children: "Ev\xE8nements"
    }),
    key: 'event',
    icon: /*#__PURE__*/_jsx(CalendarEventFill, {})
  }, {
    label: /*#__PURE__*/_jsx("span", {
      children: "Votes"
    }),
    key: 'vote',
    icon: /*#__PURE__*/_jsx(AwardFill, {})
  }, {
    label: /*#__PURE__*/_jsx("span", {
      children: "Services"
    }),
    key: 'srv',
    children: [{
      label: /*#__PURE__*/_jsx("span", {
        children: "Replay"
      }),
      key: 'replay',
      icon: /*#__PURE__*/_jsx(PlayCircleFill, {})
    }, {
      label: /*#__PURE__*/_jsx("span", {
        children: "Carte"
      }),
      key: 'map',
      icon: /*#__PURE__*/_jsx(GeoAltFill, {})
    }]
  }];
  var accountMenuItems = [{
    label: /*#__PURE__*/_jsx("span", {
      children: "Compte "
    }),
    key: 'compte',
    icon: /*#__PURE__*/_jsx(DoorOpenFill, {})
  }];
  var handleNewEvent = function handleNewEvent() {
    if (userIsConnected) setIsEventBoxVisible(true);else setConnectDrawerVisible(true);
  };
  var handleNewTicket = function handleNewTicket(e) {
    setSelectedEvent(e);
    setIsTicketBookVisible(true);
  };
  var handleShowEventDetails = function handleShowEventDetails(e) {
    setSelectedEvent(e);
    setShowEventDetails(true);
  };
  useEffect(function () {
    axios.post(Common.baseApiUrl + 'authenticateuser', {
      id: JSON.parse(localStorage.getItem('userData')) != null ? JSON.parse(localStorage.getItem('userData')).id : null
    }).then(function (response) {
      if (response.data.auth == true) {
        localStorage.setItem('userData', JSON.stringify(response.data.user));
        setUserIsConnected(true);
      } else {
        localStorage.removeItem('userData');
        localStorage.removeItem('isOn');
        setUserIsConnected(false);
      }
    });
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "content-wrapper",
      style: {
        marginTop: "60px"
      },
      children: [/*#__PURE__*/_jsx("div", {
        className: "nav-wrapper",
        children: /*#__PURE__*/_jsx(Container, {
          children: /*#__PURE__*/_jsxs(Row, {
            children: [/*#__PURE__*/_jsx(Col, {
              lg: userIsConnected ? 8 : 7,
              md: 10,
              sm: 8,
              xs: 8,
              children: /*#__PURE__*/_jsx(Menu, {
                style: {
                  fontSize: "15px",
                  fontWeight: "bold",
                  color: "#663B10"
                },
                overflowedIndicator: /*#__PURE__*/_jsx(DownOutlined, {}),
                onClick: function onClick(e) {
                  switch (e.key) {
                    case "logo":
                      navigate('/home');
                      break;
                    case "home":
                      navigate('/home');
                      break;
                    case "event":
                      navigate('/home/events');
                      break;
                    case "vote":
                      navigate('/home/vote');
                      break;
                    case "replay":
                      navigate('/home/medias');
                      break;
                    case "map":
                      navigate('/home/map');
                      break;
                    case "compte":
                      navigate('/home/compte');
                      break;
                  }
                },
                mode: "horizontal",
                items: userIsConnected ? menuItems.concat(accountMenuItems) : menuItems
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 3,
              className: "d-lg-block d-md-none d-sm-none d-none",
              children: /*#__PURE__*/_jsx("div", {
                className: "all-center",
                children: /*#__PURE__*/_jsx(Button, {
                  type: "default",
                  onClick: handleNewEvent,
                  style: {
                    background: '#EB9800',
                    color: '#FFFFFF',
                    border: 'none'
                  },
                  children: /*#__PURE__*/_jsx("b", {
                    children: "CREER UN EVENEMENT"
                  })
                })
              })
            }), !userIsConnected && /*#__PURE__*/_jsx(Col, {
              lg: 2,
              md: 2,
              sm: 4,
              xs: 4,
              children: /*#__PURE__*/_jsx("div", {
                className: "all-center",
                children: /*#__PURE__*/_jsx(Button, {
                  type: "primary",
                  onClick: showConnectDrawer,
                  children: /*#__PURE__*/_jsx("b", {
                    children: "CONNEXION"
                  })
                })
              })
            }), userIsConnected && /*#__PURE__*/_jsx(Col, {
              lg: 1,
              md: 2,
              sm: 3,
              xs: 4,
              className: "all-center",
              children: /*#__PURE__*/_jsx(Space, {
                orientation: "horizontal",
                children: /*#__PURE__*/_jsx("a", {
                  className: "right-link",
                  onClick: showDrawer,
                  children: /*#__PURE__*/_jsx(Grid3x3GapFill, {
                    size: 24
                  })
                })
              })
            })]
          })
        })
      }), /*#__PURE__*/_jsx(Outlet, {
        style: {
          flex: 1
        },
        context: {
          setConnectDrawerVisible: setConnectDrawerVisible,
          setIsEventBoxVisible: setIsEventBoxVisible,
          setIsTicketBookVisible: setIsTicketBookVisible,
          handleShowEventDetails: handleShowEventDetails,
          handleNewTicket: handleNewTicket,
          handleNewEvent: handleNewEvent,
          setSelectedEvent: setSelectedEvent,
          userIsConnected: userIsConnected,
          setUserIsConnected: setUserIsConnected
        }
      }), /*#__PURE__*/_jsx("div", {
        className: "first-footer-section",
        children: /*#__PURE__*/_jsx(Container, {
          children: /*#__PURE__*/_jsxs(Row, {
            children: [/*#__PURE__*/_jsx(Col, {
              lg: 3,
              md: 3,
              sm: 4,
              children: /*#__PURE__*/_jsxs("div", {
                className: "footer-box",
                children: [/*#__PURE__*/_jsx("h4", {
                  children: "Qui sommes-nous ?"
                }), /*#__PURE__*/_jsxs("p", {
                  children: [/*#__PURE__*/_jsx("b", {
                    children: "Naatou"
                  }), " est votre partenaire pour un evenement r\xE9ussi et s\xE9curis\xE9."]
                })]
              })
            }), /*#__PURE__*/_jsxs(Col, {
              lg: 3,
              md: 3,
              sm: 4,
              children: [/*#__PURE__*/_jsx("h4", {
                children: "Liens utiles"
              }), /*#__PURE__*/_jsx(Link, {
                to: "/cgu",
                children: "Conditions g\xE9n\xE9rales d'utilisation"
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Link, {
                to: "/partenaires",
                children: "Nos partenaires"
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Link, {
                to: "/about",
                children: "A propos"
              }), /*#__PURE__*/_jsx("br", {})]
            }), /*#__PURE__*/_jsx(Col, {
              lg: 3,
              md: 3,
              sm: 4,
              children: /*#__PURE__*/_jsxs("div", {
                className: "footer-box",
                children: [/*#__PURE__*/_jsx("h4", {
                  children: "Nos r\xE9seaux sociaux"
                }), /*#__PURE__*/_jsxs(Space, {
                  direction: "vertical",
                  children: [/*#__PURE__*/_jsx(Button, {
                    href: "https://facebook.com/naatougn",
                    target: "_blank",
                    type: "default",
                    icon: /*#__PURE__*/_jsx(Facebook, {}),
                    children: " Page Facebook"
                  }), /*#__PURE__*/_jsx(Button, {
                    href: "https://twitter.com/#",
                    target: "_blank",
                    type: "default",
                    icon: /*#__PURE__*/_jsx(Twitter, {}),
                    children: " Page Twitter"
                  })]
                })]
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 3,
              md: 3,
              sm: 4,
              children: /*#__PURE__*/_jsxs("div", {
                className: "footer-box",
                children: [/*#__PURE__*/_jsx("h4", {
                  children: "Nos services ?"
                }), /*#__PURE__*/_jsxs("ul", {
                  children: [/*#__PURE__*/_jsx("li", {
                    children: /*#__PURE__*/_jsx("a", {
                      href: "https://guisoftlab.com/web-development/",
                      target: "_blank",
                      children: "Agence creative"
                    })
                  }), /*#__PURE__*/_jsx("li", {
                    children: /*#__PURE__*/_jsx("a", {
                      href: "#",
                      children: "Publicit\xE9"
                    })
                  })]
                })]
              })
            })]
          })
        })
      })]
    }), userIsConnected && /*#__PURE__*/_jsx(Drawer, {
      title: "Mon compte",
      width: 330,
      closable: true,
      onClose: onDrawerClose,
      open: drawerVisible,
      children: /*#__PURE__*/_jsx(AccountNav, {})
    }), connectDrawerVisible == true && /*#__PURE__*/_jsx(UserConnectDrawer, {
      display: connectDrawerVisible,
      hideDrawer: function hideDrawer() {
        setConnectDrawerVisible(false);
      }
    }), selectedEvent != null && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Modal, {
        open: isTicketBookVisible,
        onCancel: function onCancel() {
          setIsTicketBookVisible(false);
        },
        width: {
          xs: '95%',
          sm: '80%',
          md: '70%',
          lg: '60%',
          xl: '50%',
          xxl: '40%'
        },
        maskClosable: false,
        centered: true,
        footer: null,
        title: /*#__PURE__*/_jsx("h6", {
          style: {
            color: '#645D5D'
          },
          children: /*#__PURE__*/_jsx("b", {
            children: "Prenez votre ticket en une minute"
          })
        }),
        destroyOnClose: true,
        children: /*#__PURE__*/_jsx("div", {
          style: {
            padding: "22px"
          },
          children: /*#__PURE__*/_jsx(BookTicket, {
            event: selectedEvent
          })
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        open: showEventDetails,
        onClose: function onClose() {
          setShowEventDetails(false);
        },
        width: "90%",
        headerStyle: {
          background: "#F8F1E9"
        },
        title: /*#__PURE__*/_jsx("b", {
          children: selectedEvent.label
        }),
        destroyOnClose: true,
        children: /*#__PURE__*/_jsx(EventDetails, {
          event_id: selectedEvent.id,
          createNewTicket: handleNewTicket
        })
      })]
    }), /*#__PURE__*/_jsx(Drawer, {
      open: isEventBoxVisible,
      onClose: function onClose() {
        setIsEventBoxVisible(false);
      },
      width: "98%",
      title: /*#__PURE__*/_jsx("b", {
        children: "Annoncer un \xE9v\xE8nement"
      }),
      destroyOnClose: true,
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 5,
          md: 6,
          sm: 12,
          children: /*#__PURE__*/_jsx(NewEventBox, {})
        }), /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsx(Row, {
            className: "d-flex justify-content-center",
            children: /*#__PURE__*/_jsx(Col, {
              lg: 8,
              md: 9,
              children: /*#__PURE__*/_jsx(Image, {
                className: "text-align-center",
                src: "/drawables/had_c.png",
                preview: false
              })
            })
          })
        })]
      })
    })]
  });
};
export default Home;